import { observer } from 'mobx-react-lite';
import { WorkspacePanel } from '../../../panels/workspace-panel';
import React from 'react';
import { WorkspacePanelProvider } from '../../../panels/workspace-panel-provider';
import { Panel } from '../../../panels/panel';
import { BoloPanelHeader } from './bolo-panel-header';
import {
    ExandablePanelSizeProvider,
    useExpandablePanelSizeState,
} from '../../../panels/expandable-panel-size';
import { RemovedEventPanelFormFieldsProvider } from '../../../event-panel/event-panel-form/form-persistence/use-locally-removed-fields';
import { BoloPanelBody } from './bolo-panel-body';
import { WorkspacePanelIntegratedBoloPanelProvider } from '../state/integrated-bolo-panel-provider';
import { ActiveBoloPanelTabProvider } from '../state/active-bolo-panel-tab-provider';
import { BoloPanelAdditionalInfosProvider } from '../additional-infos/bolo-panel-additional-infos-provider';
import { BoloPanelActionHandler } from '../bolo-panel-action-handler';
import { useFormHasHadDataSetAtLeastOnceContext } from '../../../event-panel/event-state/form-has-had-data-set-at-least-once';

const BoloPanelInner = observer(function BoloPanelInner({ panel }: { panel: WorkspacePanel }) {
    const { resizeOptions, sizeProps } = useExpandablePanelSizeState(panel, 'BOLO');

    return (
        <Panel
            panel={panel}
            body={<BoloPanelBody />}
            header={<BoloPanelHeader />}
            resizeOptions={resizeOptions}
            {...sizeProps}
            closeButtonProps={{ size: 'sm' }}
        />
    );
});

export const BoloPanel = observer(function BoloPanel({
    panel,
}: {
    panel: WorkspacePanel;
}): React.ReactElement {
    const formHasHadDataSetAtLeastOnce = useFormHasHadDataSetAtLeastOnceContext();

    return (
        <WorkspacePanelProvider workspacePanel={panel}>
            <RemovedEventPanelFormFieldsProvider>
                <ExandablePanelSizeProvider>
                    <WorkspacePanelIntegratedBoloPanelProvider boloId={panel.linkedEntityId}>
                        <ActiveBoloPanelTabProvider>
                            <BoloPanelAdditionalInfosProvider>
                                <>
                                    <BoloPanelActionHandler
                                        boloId={panel.linkedEntityId}
                                        formHasHadDataSetAtLeastOnce={formHasHadDataSetAtLeastOnce}
                                    />
                                    <BoloPanelInner panel={panel} />
                                </>
                            </BoloPanelAdditionalInfosProvider>
                        </ActiveBoloPanelTabProvider>
                    </WorkspacePanelIntegratedBoloPanelProvider>
                </ExandablePanelSizeProvider>
            </RemovedEventPanelFormFieldsProvider>
        </WorkspacePanelProvider>
    );
});
